/**
 * Canvas UI helpers for multi-step flows: nodes that share {@code flowEntryId}
 * are shown with a common banner (title + accent from the flow entry's {@code flowConfig}).
 */

import { isDynamicForm } from './formTypeConstants';
import { getColourFromString } from './ColourNameGenerator';

function getRawComponentData(component) {
  if (!component) return {};
  return component.rawComponentData || component.componentData || {};
}

/**
 * @param {Array<{ componentId: string, type: string, rawComponentData?: object, componentData?: object }>|undefined} components
 * @param {string} componentId — canvas node id
 * @returns {null | {
 *   title: string,
 *   accent: string,
 *   memberCount: number,
 *   isEntry: boolean,
 *   flowEntryId: string,
 * }}
 */
export function getFlowGroupDisplay(components, componentId) {
  const self = components?.find(c => c.componentId === componentId);
  if (!self || !isDynamicForm(self.type)) return null;

  const raw = getRawComponentData(self);
  const flowEntryId = raw.flowEntryId ?? null;
  if (!flowEntryId) return null;

  const entry = components?.find(c => c.componentId === flowEntryId);
  const entryRaw = getRawComponentData(entry);
  const title = (typeof entryRaw.flowConfig?.title === 'string' && entryRaw.flowConfig.title.trim())
    ? entryRaw.flowConfig.title.trim()
    : 'Untitled flow';

  const accentHex = entryRaw.flowConfig?.branding?.accentColor;
  const accent = (typeof accentHex === 'string' && accentHex.trim())
    ? accentHex.trim()
    : getColourFromString(flowEntryId).border;

  const memberCount = (components || []).filter(c => {
    if (!c || !isDynamicForm(c.type)) return false;
    const r = getRawComponentData(c);
    return r.flowEntryId === flowEntryId;
  }).length;

  const isEntry = componentId === flowEntryId;

  return {
    title,
    accent,
    memberCount,
    isEntry,
    flowEntryId,
  };
}
